
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsRefundReasonDialog extends Serenity.EntityDialog<PsRefundReasonRow, any> {
        protected getFormKey() { return PsRefundReasonForm.formKey; }
        protected getIdProperty() { return PsRefundReasonRow.idProperty; }
        protected getLocalTextPrefix() { return PsRefundReasonRow.localTextPrefix; }
        protected getNameProperty() { return PsRefundReasonRow.nameProperty; }
        protected getService() { return PsRefundReasonService.baseUrl; }
        protected getDeletePermission() { return PsRefundReasonRow.deletePermission; }
        protected getInsertPermission() { return PsRefundReasonRow.insertPermission; }
        protected getUpdatePermission() { return PsRefundReasonRow.updatePermission; }

        protected form = new PsRefundReasonForm(this.idPrefix);

    }
}